/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

/**
 * OAuth Configuration Model
 *
 * Represents OAuth2 configuration extracted from OpenAPI specification
 */

export interface OAuthConfig {
  /** OAuth2 client ID */
  clientId: string | null;

  /** Available OAuth2 scopes */
  scopes: string[];
}

/**
 * Default OAuth configuration
 */
export const DEFAULT_OAUTH_CONFIG: OAuthConfig = {
  clientId: null,
  scopes: []
};
